import MyModal from "./MyModal";
import Navette from "../../Model/Navette";
import { define_button_className } from "./MyModal";
import { define_button_text } from "./MyModal";

interface StatusModalProps {
    navette: Navette;
}

export default function StatusModal(props: StatusModalProps) {
    return (
        <MyModal
            className={define_button_className(props.navette.retourClient)}
            style={{padding: "4px", width: "90px", color: "white", marginLeft: "14px"}}
            textButton={define_button_text(props.navette.retourClient)}
            element={"statusModal"}
            navette={props.navette}
        ></MyModal>
    );
}